import { Stack } from "@altimateai/lego";
import QuickstartHeader from "./components/QuickstartHeader";
import PathSelector from "./components/PathSelector";
import InviteBox from "./components/invitebox/InviteBox";

function Quickstart() {
  return (
    <Stack direction="column" gap="xl" className="al-px-4 sm:al-px-6 md:al-px-12 lg:al-px-20 xl:al-px-28">
      <QuickstartHeader />
      <PathSelector />
      <InviteBox />
    </Stack>
  );
}

export default Quickstart;
